<template>
  <div>
    <transition :name="routerTransition" mode="out-in" v-if="isLoaded">
      <div>
        <esp-header :dataPage="dataPage" ref="espHeader" v-if="isLoaded"></esp-header>
        <router-view :dataPage="dataPage" v-if="isLoaded" />
        <esp-footer :dataPage="dataPage" ref="espFooter" v-if="isLoaded"></esp-footer>
      </div>
    </transition>
  </div>
</template>
<style scoped>
  .footer-test{
    width:100%; height:100px; background:orange
  }
</style>

<script>
// FIREBASE
import "firebase/auth";
const firebase = require("firebase");
require("firebase/firestore");
require("firebase/auth");
var db = firebase.firestore();

// CONFIG
import  { themeConfig, irisConfig }  from "@/../siteConfig.js";

import EspHeader from "@/layouts/Header.vue"
import EspFooter from "@/layouts/Footer.vue";

export default {
  components: {
    EspHeader,
    EspFooter
  },
  data() {
    return {
      routerTransition: themeConfig.routerTransition || "none",
      everLoad:false,
      irisConfig:irisConfig,
      imgLogo:'',
      dataIris:{
        customizableVar:[],
        customizableVarLoaded:false,
        menuHeader:{
          itemsMenu:{
            children:[]
          }
        },
        menuHeaderLoaded:false,
        pages:[],
        pagesLoaded:false,
        articles:[],
        articlesLoaded:false
      },
      dataPage:{
        customizableVar:[
          { 
            value:{
              value: "0f555d"
            }
          }
        ]
      }
    };
  },
  metaInfo() {
    return { 
        title: this.dataPage.metaTitle ? this.dataPage.metaTitle : "Lycée Gustave FLAUBERT à Rouen - Enseignement Général, Technologique, Professionnel et Supérieur",
        meta: [
            { name: 'description', content: this.dataPage.metaDescription ? this.dataPage.metaDescription : 'FLAUBERT est un ensemble composé d\'un lycée d\'enseignement général et technologique, d\'un lycée professionnel, et de Flaubert Sup pour l\'enseignem supérieur.'},
            { property: 'og:title', content: this.dataPage.metaTitle ? this.dataPage.metaTitle : "Lycée Gustave FLAUBERT à Rouen - Enseignement Général, Technologique, Professionnel et Supérieur"},
            { property: 'og:site_name', content: 'Lycée Gustave FLAUBERT'},
            { property: 'og:type', content: 'website'},    
            { name: 'robots', content: 'index,follow'} 
        ]
    }
  },
  beforeMount() {
    this.fetchData();
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      console.log("Route from : ", from, "Route to : ", to)
      this.getDataPage()
    }
  },
  methods: {
    getCustomizableVar(){
      this.dataIris.customizableVar=[]
      let parentThis = this
      db.collection("customers")
        .doc(this.irisConfig.customers)
        .collection('sites')
        .doc(this.irisConfig.sites)
        .onSnapshot(function(doc) {
          if(doc.data().deleteDate==null){
            parentThis.dataIris.customizableVar.push(doc.data().customizableVar)
            parentThis.dataIris.customizableVarLoaded=true
            parentThis.dataIris.googleAnalyticsID = doc.data().googleAnalyticsID
          
            //console.log(parentThis.dataIris.googleAnalyticsID) 
          }            
        })
    },
    getMenuHeader(){
      this.dataIris.customizableVar=[]
      let parentThis = this
      db.collection("customers")
        .doc(this.irisConfig.customers)
        .collection('sites')
        .doc(this.irisConfig.sites)
        .collection('Menu-principale_Menu')
        .doc(this.irisConfig.menuHeader)
        .onSnapshot(function(doc) {
          if(doc.data().deleteDate==null){
            parentThis.dataIris.menuHeader=doc.data()
            //console.log(doc.data())
            parentThis.dataIris.menuHeaderLoaded=true
          }
        })
    },
    getPages(){
      this.dataIris.pages=[]
      let parentThis = this
      db.collection("customers")
        .doc(this.irisConfig.customers)
        .collection('sites')
        .doc(this.irisConfig.sites)
        .collection('pages')
        .onSnapshot(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
            if(doc.data().deleteDate==null){
              parentThis.dataIris.pages.push(doc.data())
            }
          })
          parentThis.dataIris.pagesLoaded=true
        })
    },
    getArticles(){
      this.dataIris.pages=[]
      let parentThis = this
      db.collection("customers")
        .doc(this.irisConfig.customers)
        .collection('sites')
        .doc(this.irisConfig.sites)
        .collection('articles')
        .onSnapshot(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
             if(doc.data().deleteDate==null){
              parentThis.dataIris.articles.push(doc.data())
             }
          })
          //console.log("articles", parentThis.dataIris.articles)
          parentThis.dataIris.articlesLoaded=true
        })
    },
    getDataPage(){
      this.everLoad = true
      if(this.$route.name=="actu-view"){
        if(this.$route.params.id){
          // Recherche par id
          console.log("recherche article par id")
          this.dataPage = this.dataIris.articles.find(article => article.id === this.$route.params.id) 
        }else{
          // Recherche par route
          console.log("recherche article par route")
          this.dataPage = this.dataIris.articles.find(article => article.route === this.$route.params.route) 
        }
      }else{
        if(this.$route.params.id){
          // Recherche par id
          console.log("recherche par id", this.$route)
          this.dataPage = this.dataIris.pages.find(page => page.id === this.$route.params.id) 
        }else{
          // Recherche par route
          console.log("recherche par route", this.$route)
          this.dataPage = this.dataIris.pages.find(page => page.route === this.$route.params.route) 
        }
      }
     
    },
    fetchData() {
      this.getCustomizableVar(),
      this.getPages(),
      this.getMenuHeader()
      this.getArticles()
    }
  },
  computed:{
    isLoaded: function () {
      if(this.dataIris.customizableVarLoaded && this.dataIris.menuHeaderLoaded && this.dataIris.pagesLoaded  && this.dataIris.articlesLoaded ){    
        
      if(this.everLoad==false){
        this.getDataPage()
      }    
        return true
      }else{
        return false
      }
    }
  }
};
</script>

